import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function Hero() {
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  return <section className="relative overflow-hidden bg-white pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-42">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl text-center mx-auto lg:mx-0" data-id="element-45">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 mb-6 leading-tight" data-id="element-46">
              Finally... A Simple Solution For Women Over 40 Who Can't Lose
              Weight No Matter What They Try
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed" data-id="element-47">
              The real reason you're struggling isn't willpower — it's your
              metabolism. CitrusBurn™ was specially formulated to fix that.
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-48">
              <a href="https://40dec9flnm4htzxbxn-n174kzw.hop.clickbank.net" onClick={handleCtaClick} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#E8441A] rounded-full hover:bg-[#C8390F] hover:scale-105 shadow-lg hover:shadow-xl w-full sm:w-auto text-center" data-id="element-49">
                YES! I Want To Burn Fat Faster →
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-md lg:max-w-none flex justify-center" data-id="element-50">
            <div className="absolute inset-0 bg-[#E8441A]/10 rounded-full blur-3xl transform scale-75" data-id="element-51"></div>
            <img src="https://cdn.magicpatterns.com/uploads/28dcvLv6VGP65preurQWbw/1_bottle.png" alt="CitrusBurn Supplement Bottle" className="relative z-10 w-full max-w-[400px] object-contain drop-shadow-2xl" data-id="element-52" />
          </motion.div>
        </div>
      </div>
    </section>;
}